export const pageTitle =
	'Hire Freelancers & VPS Hosting | Marketplace for Talent & Managed VPS';
export const pageDescription =
	"Discover affordable managed VPS hosting on secure Amazon servers, premium web hosting plans, and a trusted marketplace to hire skilled freelancers for your projects. Fast, reliable, and scalable solutions for businesses of all sizes.";
